/* tslint:disable */
/* eslint-disable */
/**
 * LTCS gateway API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiV2OffersPostRequest
 */
export interface ApiV2OffersPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiV2OffersPostRequest
     */
    accountType?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApiV2OffersPostRequest
     */
    buildSeries: Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof ApiV2OffersPostRequest
     */
    dropoffAt: Date;
    /**
     * 
     * @type {string}
     * @memberof ApiV2OffersPostRequest
     */
    location: string;
    /**
     * 
     * @type {string}
     * @memberof ApiV2OffersPostRequest
     */
    partner?: string;
    /**
     * 
     * @type {number}
     * @memberof ApiV2OffersPostRequest
     */
    paymentProfileId?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiV2OffersPostRequest
     */
    paymentType?: ApiV2OffersPostRequestPaymentTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof ApiV2OffersPostRequest
     */
    pickupAt: Date;
    /**
     * 
     * @type {string}
     * @memberof ApiV2OffersPostRequest
     */
    profileType?: string;
}


/**
 * @export
 */
export const ApiV2OffersPostRequestPaymentTypeEnum = {
    Creditcard: 'CREDITCARD',
    Invoice: 'INVOICE',
    Directdebit: 'DIRECTDEBIT',
    Partner: 'PARTNER',
    Withdrawal: 'WITHDRAWAL',
    Paypal: 'PAYPAL'
} as const;
export type ApiV2OffersPostRequestPaymentTypeEnum = typeof ApiV2OffersPostRequestPaymentTypeEnum[keyof typeof ApiV2OffersPostRequestPaymentTypeEnum];


/**
 * Check if a given object implements the ApiV2OffersPostRequest interface.
 */
export function instanceOfApiV2OffersPostRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "buildSeries" in value;
    isInstance = isInstance && "dropoffAt" in value;
    isInstance = isInstance && "location" in value;
    isInstance = isInstance && "pickupAt" in value;

    return isInstance;
}

export function ApiV2OffersPostRequestFromJSON(json: any): ApiV2OffersPostRequest {
    return ApiV2OffersPostRequestFromJSONTyped(json, false);
}

export function ApiV2OffersPostRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiV2OffersPostRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'accountType': !exists(json, 'account_type') ? undefined : json['account_type'],
        'buildSeries': json['build_series'],
        'dropoffAt': (new Date(json['dropoff_at'])),
        'location': json['location'],
        'partner': !exists(json, 'partner') ? undefined : json['partner'],
        'paymentProfileId': !exists(json, 'payment_profile_id') ? undefined : json['payment_profile_id'],
        'paymentType': !exists(json, 'payment_type') ? undefined : json['payment_type'],
        'pickupAt': (new Date(json['pickup_at'])),
        'profileType': !exists(json, 'profile_type') ? undefined : json['profile_type'],
    };
}

export function ApiV2OffersPostRequestToJSON(value?: ApiV2OffersPostRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'account_type': value.accountType,
        'build_series': value.buildSeries,
        'dropoff_at': (value.dropoffAt.toISOString()),
        'location': value.location,
        'partner': value.partner,
        'payment_profile_id': value.paymentProfileId,
        'payment_type': value.paymentType,
        'pickup_at': (value.pickupAt.toISOString()),
        'profile_type': value.profileType,
    };
}

